export default "__VITE_ASSET__3fcdfc3f__"